import { useFiltersContext } from "components/Shared/GlobalFilter/context/filtersContext"
import { FiltersType } from "components/Shared/GlobalFilter/context/interfaces"
import {
	MONTH_PRESET_ID,
	QUARTER_PRESET_ID,
	YEAR_PRESET_ID,
	MOBILE_YEAR_PRESET_ID,
	CUSTOM_RANGES_ID,
} from "components/Shared/MultiRangeCalendar/constants"
import {
	DEPARTMENTS,
	CATEGORIES,
	SUBCATEGORIES,
	FINELINE,
} from "components/Shared/GlobalFilter/constants"
import { ALL_CODE } from "helpers/service"
import { Tuple } from "components/Shared/Interfaces"

export type TabOptions = "level" | "brand" | "channel" | "format" | "location"

const filtersForHeader = [FINELINE, SUBCATEGORIES, CATEGORIES, DEPARTMENTS]

const levels: Record<TabOptions, Array<string>> = {
	level: ["departments", "categories", "subcategories", "fineline", "products"],
	brand: ["brands", "products"],
	channel: ["channels"],
	format: ["formats", "stores"],
	location: ["regions", "counties", "stores"],
}

export const period: Record<string, string> = {
	[MONTH_PRESET_ID]: "month",
	[QUARTER_PRESET_ID]: "quarter",
	[YEAR_PRESET_ID]: "year",
	[MOBILE_YEAR_PRESET_ID]: "mobile",
	[CUSTOM_RANGES_ID]: "custom",
}
export const getLevel = (currentTab: TabOptions) => {
	const { filters } = useFiltersContext()
	const arr = levels[currentTab]
	const index = arr.findIndex((filter) => {
		return filters[filter]?.length == 0
	})
	if (index == -1) {
		return arr[arr.length - 1]
	}
	return arr[index % arr.length]
}

const filterExists = (filter: Array<Tuple>, level: string) => {
	if (filter[0].code === ALL_CODE) {
		return { level, quantity: 0 }
	}
	if (filter.length === 1) {
		return { level: filter[0].name, quantity: 1 }
	}
	return { level, quantity: filter.length }
}

export const getMetricForTitles = (filters: FiltersType) => {
	const level = filtersForHeader.find((filter) => {
		return filters[filter]?.length > 0
	})
	if (level) {
		return filterExists(filters[level], level)
	}
	return { level: "departments", quantity: 0 }
}
